import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import { AnimatePresence, motion } from "framer-motion";
import Portfolio from "./pages/Portfolio";
import HoneyBuddy from "./pages/HoneyBuddy";
import SMT from "./pages/SMT";
import CDM from "./pages/CDM";
import Cakery from "./pages/Cakery";
// import TaskBuddy from "./pages/TaskBuddy";
// import Webcrack from "./pages/Webcrack";
// import Memolog from "./pages/Memolog";
// import ACMW from "./pages/ACMW";
import About from "./pages/About";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 0,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
    y: 0,
    transition: {
      duration: 0.2,
      ease: "easeIn",
    },
  },
};

const AnimatedRoutes = () => {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, delay: 50, offset: 80 });
  }, []);

  useEffect(() => {
    setIsNavigating(true);
    const timer = setTimeout(() => setIsNavigating(false), 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className={isNavigating ? "page-transitioning" : ""}>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          onAnimationComplete={() => {
            AOS.refreshHard();
          }}
        >
          <Routes location={location}>
            <Route path="/" element={<Portfolio />} />
            <Route path="/honeybuddy" element={<HoneyBuddy />} />
            <Route path="/smt" element={<SMT />} />
            <Route path="/cdm" element={<CDM />} />
            <Route path="/cakery" element={<Cakery />} />
            {/* <Route path="/taskbuddy" element={<TaskBuddy />} /> */}
            {/* <Route path="/memolog" element={<Memolog />} />
            <Route path="/webcrack" element={<Webcrack />} />
            <Route path="/acmw" element={<ACMW />} /> */}
            <Route path="/about" element={<About />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
      <CircleCursor />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Router>
        <AnimatedRoutes />
      </Router>
    </div>
  );
}

function CircleCursor() {
  useEffect(() => {
    const cursor = document.createElement("div");
    cursor.className = "circle-cursor";
    document.body.appendChild(cursor);

    const moveCursor = (e) => {
      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    };

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      document.body.removeChild(cursor);
    };
  }, []);

  return null;
}

export default App;
